import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Clock, X } from 'lucide-react';
import { DLG_BTN_SECONDARY } from '@/components/ui/dialogButtons';

interface Servicio {
  id_servicio: string;
  nombre_servicio: string;
  precio: number;
  duracion_minutos: number;
}

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  servicios: Servicio[];
}

const WorkerServiciosDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  servicios,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="
          z-[60] p-0 border border-gray-200 dark:border-white/10 bg-white dark:bg-[#1c1c1e]
          [&>button:last-child]:hidden
          flex flex-col
          !bottom-0 !left-0 !top-auto !translate-x-0 !translate-y-0
          w-full max-w-none max-h-[85vh] rounded-t-2xl rounded-b-none
          data-[state=open]:slide-in-from-bottom data-[state=closed]:slide-out-to-bottom
          sm:!bottom-auto sm:!left-1/2 sm:!top-1/2 sm:!-translate-x-1/2 sm:!-translate-y-1/2
          sm:w-[95%] sm:max-w-2xl sm:mx-auto sm:h-auto sm:max-h-[85vh] sm:rounded-xl sm:shadow-xl
        "
      >
        <div className="px-4 sm:px-6 pt-5 pb-3 shrink-0 relative">
          <DialogHeader>
            <DialogTitle className="text-lg sm:text-xl font-semibold text-[#103254] dark:text-blue-400 pr-10">
              Servicios asignados
            </DialogTitle>
          </DialogHeader>
          <button
            onClick={() => onOpenChange(false)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:text-gray-800 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 sm:px-6 pb-5">
          {servicios.length > 0 ? (
            <div className="rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {servicios.map((s) => (
                  <div
                    key={s.id_servicio}
                    className="border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 rounded-lg p-4 shadow-sm"
                  >
                    <p className="font-semibold text-gray-800 dark:text-white">
                      {s.nombre_servicio}
                    </p>
                    <p className="text-gray-600 dark:text-gray-400 mt-1">
                      {s.precio.toFixed(2)} €
                    </p>
                    <p className="text-gray-600 dark:text-gray-400 flex items-center gap-1 mt-1">
                      <Clock className="w-4 h-4" />
                      {s.duracion_minutos} min
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-6">
              No tienes servicios asignados.
            </p>
          )}
        </div>

        <DialogFooter className="px-4 sm:px-6 pt-2 pb-5 sm:pb-4 shrink-0 border-t border-gray-100 dark:border-white/10">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className={`w-full ${DLG_BTN_SECONDARY}`}
          >
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WorkerServiciosDialog;